<template>
  <div id="promocode-link" v-if="isShow()">
    <template v-if="isRealBind()">
      <div class="mb-3">
        <span class="me-1">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-circles-relation"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9.183 6.117a6 6 0 1 0 4.511 3.986" /><path d="M14.813 17.883a6 6 0 1 0 -4.496 -3.954" /></svg>
        </span>
        <b class="was-bind">Этот пост связан с промокодом</b>
      </div>
    </template>
    <div class="mb-3" v-else-if="isCandidateBind()">
      <span class="me-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-circles-relation"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9.183 6.117a6 6 0 1 0 4.511 3.986" /><path d="M14.813 17.883a6 6 0 1 0 -4.496 -3.954" /></svg>
      </span>
      <b class="will-bind">После отложенной или прямой публикации этот пост будет связан с промокодом</b>
    </div>
    <div class="mb-2 d-flex align-items-center gap-2" v-if="coupon.link">
      <b>Ссылка:</b>
      <span class="text-truncate link">
          {{ shortLink }}
        </span>
      <button class="btn btn-sm btn-outline-primary" @click="copyLink">
        Копировать
      </button>
    </div>
    <div class="mb-2" v-if="coupon.name">
      <b>Название:</b> {{ coupon.name }}
    </div>
    <div class="mb-2" v-if="coupon.desc">
      <b>Описание:</b> {{ coupon.desc }}
    </div>
  </div>
  <div v-else>
    <div class="spinner-border spinner-border-sm me-2"></div>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from "vue"
import Api from "./services/Api"
import Helper from "@/services/Helper"
import Notify from "@/services/Notify"

const props = defineProps({
  payload: {
    type: Object,
    default: () =>{},
  }
})

let show = ref(false)

const payload = reactive({
  post_id: 0,
  post_type_id: 0,
  post_bind: false,
  coupon_id: 0,
  source_id: 0,
})

const coupon = reactive({
  bind: false,
  link: "",
  name: "",
  desc: "",
})

let shortLink = computed(() => {
  const link = coupon.link
  const max = 40

  if (link.length <= max) {
    return link
  }
  return link.slice(0, 30) + '…' + link.slice(-8)
})

onMounted(async () => {
  updatePayload(props.payload)

  markUnshow()

  if (await issetCoupon()) {
    markRealBindCoupon()
  }
  
  if (isCandidateBind()) {
    await loadCoupon()
  }

  markShow()
})

async function loadCoupon() {
  let response = (await Api.item(
      payload.coupon_id,
      payload.source_id,
  ))?.data?.data

  if (!Helper.isEmpty(response)) {
    setCoupon(response)
    return true
  }

  throw new Error("Пустые данные от api по детализации купона");
}

async function issetCoupon() {
  let response = (await Api.lnkPost(
      payload.coupon_id,
      payload.source_id,
  ))?.data?.data

  if (Helper.isEmpty(response)) {
    return false
  }

  let posts = response[0]?.posts ?? []

  return Object.values(posts).some(val => {
    let postId = val?.post_id ?? null
    let postTypeId = val?.post_type_id ?? null

    return (
        postId != null &&
        postTypeId != null &&
        Number(postId) === Number(payload.post_id) &&
        Number(postTypeId) === Number(payload.post_type_id)
    )
  })
}

function markRealBindCoupon() {
  coupon.bind = true
}

function setCoupon(item) {
  coupon.link = item?.coupon_gotolink ?? null
  coupon.name = item?.coupon_name ?? null
  coupon.desc = item?.coupon_descr ?? null
}

function updatePayload(query) {
  payload.post_id = query.post_id
  payload.post_type_id = query.post_type_id
  payload.post_bind = query.post_bind
  payload.coupon_id = query.coupon_id
  payload.source_id = query.source_id
}

function markShow() {
  show.value = true
}

function markUnshow() {
  show.value = false
}

function isShow() {
  return show.value === true
}

function isCandidateBind() {
  return payload.post_bind === true
}
function isRealBind() {
  return coupon.bind === true
}

async function copyLink() {
  try {
    await navigator.clipboard.writeText(coupon.link)
    Notify.success("Ссылка скопирована")
  } catch {
    Notify.error("Не удалось скопировать")
  }
}
</script>

<style scoped src="./css/style.css"></style>
